import "../css/Titles.css";

function Titles() {
    return (
        <div className="titles-main">
            <div className="titles-main-container">
                <div className="main-slideshow-container">
                    <div className="main-aboutme-content">
                        <h3 className="main-aboutme-title">Education</h3>
                        <p>
                            PhD University of Toronto, Department of Civil
                            Engineering, Canada <br></br>MSc BSc Cracow
                            University of Technology, Department of Civil
                            Engineering, Poland
                        </p>
                        <h3 className="main-aboutme-title">
                            Professional Experience
                        </h3>
                        <p>
                            Professor<br></br> University Research Chair
                            <br></br> Department of Civil and Environmental
                            Engineering,
                            <br></br> University of Waterloo.<br></br>
                            Waterloo,Canada.<br></br> <br></br> Visiting
                            Professor:
                            <br></br>
                            University of Stuttgart , Germany <br></br>Technical
                            University of Berlin <br></br> Germany University of
                            Wuppertal, Germany<br></br>
                            Cracow University of Technology Poland <br></br>
                            Silesian University of Technology, Poland<br></br>
                            <br></br>Design Engineer: <br></br>Cracow Poland{" "}
                            <br></br>Toronto Canada.
                        </p>
                        <h3 className="main-aboutme-title">
                            Awards and Honors
                        </h3>
                        <p>
                            University Research Chair, University of Waterloo,
                            Canada<br></br> Fellow of the Canadian Academy of
                            Engineering<br></br>
                            Fellow of the Canadian Society of Civil Engineering
                            <br></br>
                            Fellow of the American Concrete Institute Humboldt
                            <br></br>
                            Research Fellowships, Germany
                        </p>
                        <h3 className="main-aboutme-title">
                            Professional Affliations
                        </h3>
                        <p>
                            Canadian Society of Civil Engineering, CSCE<br></br>
                            American Society of Civil Engineers, ASCE<br></br>{" "}
                            American Concrete Institute, ACI<br></br> ACI
                            Committee 445: Shear and Torsion,<br></br> ACI 445C:
                            Punching Shear in Slabs,<br></br> ACI Committee 440:
                            Fiber Reinforced polymer reinforcements.<br></br>{" "}
                            ACI 440C <br></br>ACI Committee 564:3-D Printing
                            with cementitious materials<br></br>
                            ACI Committee 435: Deflections of Reinforced
                            Concrete Structures. fib-CEB The International
                            Federation for Structural Concrete Transportation
                            Research Board TRB
                            <br></br>
                            TRB Committee AKB10 - Innovative Highway Structures
                            and Appurtenances Council of Polish Engineers in
                            North America<br></br>Professional Engineer&#39;s
                            Ontario (PEO)
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Titles;
